import { FilterMatchMode } from "primereact/api";

export class Laboral {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            institucion: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: true,
                filterPlaceholder: 'Buscar institución',
                filterField: 'institucion',
                matchMode: FilterMatchMode.CONTAINS,
                header: 'NOMBRE INSTITUCIÓN:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            cargo: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: false,
                matchMode: FilterMatchMode.CONTAINS,
                header: 'CARGO / FUNCIÓN:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            fecha_inicio: {
                value: new Date(),
                export: false,
                table: true,
                sort: false,
                filter: false,
                matchMode: FilterMatchMode.CONTAINS,
                header: 'PERÍODO DESDE:',
                required: 'Fecha requerida',
            },
            fecha_fin: {
                value: new Date(),
                export: false,
                table: true,
                sort: false,
                filter: false,
                matchMode: FilterMatchMode.CONTAINS,
                header: 'PERÍODO HASTA:',
                required: 'Fecha requerida',
            },
            pais: {
                value: null,
                export: false,
                table: false,
                header: 'País:',
                required: 'País es requerido',
            },
            provincia: {
                value: null,
                export: false,
                table: true,
                header: 'Provincia:',
                required: 'Provincia es requerida',
            },
            ciudad: {
                value: null,
                export: false,
                table: true,
                header: 'Ciudad:',
                required: 'Ciudad es requerida',
                matchMode: FilterMatchMode.CONTAINS,
            },
            canton: {
                value: '',
                export: false,
                table: false,
                header: 'Ciudad / Cantón:',
                required: 'Ciudad es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
        }
    }

    optionLabel = 'nombre';
}
